import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect, useRef, lazy, Suspense } from 'react';
import { useTeamStore } from './store/useTeamStore';
import { fetchTeamMembers } from './services/api';
import MainLayout from './layouts/MainLayout';
import Home from './pages/Home';

// Lazy loading de páginas menos críticas
const Properties = lazy(() => import('./pages/Properties'));
const PropertyDetail = lazy(() => import('./pages/PropertyDetail'));
const Blog = lazy(() => import('./pages/Blog'));
const About = lazy(() => import('./pages/About'));
const Corporate = lazy(() => import('./pages/Corporate'));
const ChacaraFlora = lazy(() => import('./pages/ChacaraFlora'));
const Contact = lazy(() => import('./pages/Contact'));
const Favorites = lazy(() => import('./pages/Favorites'));
const Advertise = lazy(() => import('./pages/Advertise'));
const FinancingSimulator = lazy(() => import('./pages/FinancingSimulator'));
const JoinUs = lazy(() => import('./pages/JoinUs'));
const Admin = lazy(() => import('./pages/Admin'));

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

function MetaPixelTracker() {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    window.fbq?.('track', 'PageView');
  }, [location.pathname, location.search]);

  return null;
}

// Componente de loading
const PageLoader = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-forest-900"></div>
  </div>
);

function App() {
  const setTeamMembers = useTeamStore(state => state.setTeamMembers);

  useEffect(() => {
    fetchTeamMembers().then(members => {
      setTeamMembers(members);
    });
  }, [setTeamMembers]);

  return (
    <Router>
      <MetaPixelTracker />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/admin" element={<Admin />} />
          <Route path="/" element={<MainLayout />}>
            <Route index element={<Home />} />
            <Route path="imoveis" element={<Properties />} />
            <Route path="imovel/:id" element={<PropertyDetail />} />
            <Route path="blog" element={<Blog />} />
            <Route path="sobre" element={<About />} />
            <Route path="corporate" element={<Corporate />} />
            <Route path="chacara-flora" element={<ChacaraFlora />} />
            <Route path="contato" element={<Contact />} />
            <Route path="favoritos" element={<Favorites />} />
            <Route path="anuncie-seu-imovel" element={<Advertise />} />
            <Route path="simulador-financiamento" element={<FinancingSimulator />} />
            <Route path="seja-um-corretor" element={<JoinUs />} />
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
